import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  Component
} from "react";
import { GlobalContext } from "./PA";
import {
  InputCopy,
  FormGroup,
  Dropdown,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Modal,
  Head,
  FormFooter,
  Subheader,
  Button,
  Card,
  Input,
  RadioGroup,
  Icon,
  Popover,
  ButtonAction,
  Tag,
  Notification
} from "xsolla-uikit";
import CardNew from "./PAcardNew";
import { Switch, Route, Link } from "react-router-dom";

export default function PAwelcome() {
  return (
    <div>
      <div className="app-root__content">
        <div className="xsui-content-block xsui-content-block--appearance-branding">
          <div className="xsui-content-block__entry">
            <div className="welcome-page">
              <div className="welcome-page_subhead">
                Welcome to your Xsolla Publisher Account!
              </div>
              <h1 className="welcome-page_head">
                Up your game in 4 simple steps
              </h1>
              <div className="steps-slider" style={{ perspective: "60em" }}>
                <div className="steps-slider-steps">
                  <div className="steps-slider-step">
                    <div className="steps-slider-step_name">
                      Create your first project
                    </div>
                  </div>
                  <div className="steps-slider-step">
                    <div className="steps-slider-step_name">
                      Connect with Xsolla
                    </div>
                  </div>
                  <div className="steps-slider-step steps-slider-step--opened">
                    <div
                      className="steps-slider-step_number"
                      style={{ height: "auto" }}
                    >
                      <div className="ReactCollapse--content">Step 3</div>
                    </div>
                    <div className="steps-slider-step_name">
                      Complete Licensing Agreement
                    </div>
                    <div
                      className="steps-slider-step_entry"
                      style={{ height: "auto" }}
                    >
                      <div className="ReactCollapse--content">
                        Fill out and accept your Licensing Agreement with
                        Xsolla. This enables you to receive payouts from
                        purchases.
                      </div>
                    </div>
                  </div>
                  <div className="steps-slider-step">
                    <div className="steps-slider-step_name">
                      Optimize your performance
                    </div>
                  </div>
                  <div className="steps-slider-entry">
                    <a
                      aria-current="false"
                      data-id="pa_welcome-page_start"
                      href="/54183/projects/create"
                    >
                      <Link to="/store/">
                        <button
                          className="xsui-button xsui-button--appearance-primary xsui-button--size-md"
                          type="button"
                        >
                          &nbsp;&nbsp;&nbsp;Create a project!&nbsp;&nbsp;&nbsp;
                        </button>
                      </Link>
                    </a>
                  </div>
                </div>
                <div
                  className="steps-slider-pictures"
                  style={{ transform: "rotateY(-0.07turn)" }}
                >
                  <div />
                  <div />
                  <div>
                    <div className="steps-slider-picture steps-slider-picture-transition-animation-enter-done">
                      <img
                        src="//cdn.xsolla.net/publisher-v4/slide-03_en.0cd1fd.png"
                        alt
                      />
                    </div>
                  </div>
                  <div />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
